import QueryString, { ParsedQs } from 'qs';
import {
  APP_PLATFORM,
  BUCKET_NAME_PROD,
  BUCKET_NAME_TEST,
  AWPENVMAP,
  NATIVE_ENV,
  isH5,
  isIOS,
  VENUS_CLIENT_PROD,
  VENUS_CLIENT_SECRET_PROD,
  VENUS_CLIENT_SECRET_TEST,
  VENUS_CLIENT_TEST,
  VENUS_ENV_PROD,
  VENUS_ENV_TEST, ENV_MAP,
} from '../constants';

// 是否在app(有KNB的环境)打开
export const isInApp = () => {
  if (!window.KNB) return false;
  return KNB.env?.isTitans;
};

// 是否在鸿蒙元服务打开
export const isInHmArk = () => {
  return !!window.atomicsdk;
};

export const safeParse = (str, defaultVal: any = {}) => {
  try {
    if (str === '' || str === undefined || str === null) return defaultVal;
    return JSON.parse(str);
  } catch (e) {
    console.log(e);
    return defaultVal;
  }
};
export const getUrlParams = (key?: string) => {
  let searchContent = window.location.search;
  const params: Record<string, any> = {};
  if (searchContent) {
    searchContent = searchContent.substring(1);
    const keyValues: string[] = searchContent.split('&');
    keyValues.forEach((keyVal) => {
      const content = keyVal.split('=');
      const valKey = content[0] || '';
      params[valKey] = content[1];
    });
  }
  if (key) {
    return params[key] || '';
  }
  return params;
};

// 对象属性连接到search字符串，原search空则新建
export const getCombToSearchStr = (Obj) => {
  const originSearchStr = location.search;
  if (!Object.keys(Obj).length) {
    return originSearchStr;
  }
  // eslint-disable-next-line
  const search = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  return `?${QueryString.stringify({ ...search, ...Obj })}`;
};

export function getQuery() {
  const [host, search] = window?.location?.href.split('?') || [];
  if (!search) return {};
  return search.split('&').reduce((dist, item) => {
    const [key, value] = item.split('=');
    return { ...dist, [key]: value };
  }, {});
}
export const getQueryValues = (key = '') => {
  // eslint-disable-next-line
    const search = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  if (key) return search[key];
  return search;
};

export const getFristQueryValue = (key, defaultVal: number | string = ''): number | string => {
  // @ts-ignore
  let cityId: number | string | string[] | ParsedQs | ParsedQs[] | undefined = getQueryValues(key);
  try {
    if (cityId && Array.isArray(cityId) && cityId.length) {
      cityId = cityId[0] || defaultVal;
    }
  } catch (e) {
    console.log(e);
  }
  return (cityId || defaultVal) as (number | string);
};

// 获取客户端类型
export const getClientType = () => (isH5 ? 'c_h5' : '');

// @ts-ignore
export const qs: typeof QueryString = isH5 ? QueryString : {
  parse(str: string) {
    const array = str.split('&');
    return array.reduce((parmas: Record<string, string>, current: string) => {
      const [key, value] = current.split('=');
      if (key) {
        parmas[key] = value || '';
      }
      return parmas;
    }, {});
  },
  stringify(data: Record<string, any>) {
    const keys = Object.keys(data);
    const array: string[] = Object.keys(data).map((key) => `${key}=${data[key]}`);
    return array.join('&');
  },
};

let _acctId: string | number = '';
export function getLoginAccountId() {
  if (isH5) {
    return sessionStorage.getItem('LOGIN_ACCOUNTID');
  }
  return _acctId;
}

export function setLoginAccountId(acctId: string | number) {
  _acctId = acctId;
  sessionStorage.setItem('LOGIN_ACCOUNTID', String(acctId));
}

export function getDeployEnv() {
  if (isH5) {
    let process;
    const _realEnv = process_env_AWP_DEPLOY_ENV;
    return _realEnv ? AWPENVMAP[_realEnv] : AWPENVMAP.test01;
  } else {
    const SLCommon = Mach.requireModule('SLCommon');
    const { env } = SLCommon?.getEnv?.() || {};
    console.log('env', env);
    return env ? (NATIVE_ENV[env] || NATIVE_ENV.Test) : NATIVE_ENV.Prod;
  }
}

export const safeCityId = (num) => {
  if (typeof num === 'number') {
    return num;
  }
  if (typeof num === 'string') {
    const _num = num.replace(/\s/g, '');
    if (/^\d+$/.test(_num)) {
      return Number(_num);
    } else {
      return 810001;
    }
  }
  return 810001;
};
export const getSafeCityId = (cityId) => safeCityId(cityId);

export const i18nRichTxtToList = (params: {text: string; data: object; paramsRender: object; commonRender: () => any;}) => {
  const {
    text, data, paramsRender, commonRender,
  } = params || {};
  if (!text) return null;
  const splitMatchList = text.match(/\{([^}]+)\}/g) || [];
  const splitList = splitMatchList.map((item) => {
    // @ts-ignore
    const [match, paramsName] = item.match(/\{([^}]+)\}/);
    return {
      matchStr: item,
      paramsName,
    };
  });
  // @ts-ignore
  return splitList.reduce((strList, item) => {
    const { matchStr, paramsName } = item;
    // @ts-ignore
    return (strList || []).reduce((dist, str) => {
      if (typeof str !== 'string') return [...dist, str];
      // @ts-ignore
      const currentList = str.split(matchStr).reduce((dist, item) => {
        const dataStr = data[paramsName];
        const dataDom = paramsRender[paramsName] ? paramsRender[paramsName](dataStr) : dataStr;
        return [...dist, item, dataDom];
      }, []).slice(0, -1);
      return [...dist, ...currentList];
    }, []);
    // @ts-ignore
  }, [text]).map((item) => (typeof item === 'string' ? commonRender(item) : item));
};

export const isProd = (includeSt = true) => {
  const env = getDeployEnv();
  let prod = env === ENV_MAP.PROD;
  let st = env === ENV_MAP.ST || env === ENV_MAP.STAGE;
  // if (env === ENV_MAP.PROD) return true;
  // if (env === ENV_MAP.ST || env === ENV_MAP.STAGE) return true;
  return includeSt ? (prod || st) : prod;
};

export const getBucketName = () => (isProd() ? BUCKET_NAME_PROD : BUCKET_NAME_TEST);
export const getVenusClient = () => (isProd() ? VENUS_CLIENT_PROD : VENUS_CLIENT_TEST);
export const getVenusClientSecret = () => (isProd()
  ? VENUS_CLIENT_SECRET_PROD
  : VENUS_CLIENT_SECRET_TEST);
export const getVenusEnvironment = () => (isProd() ? VENUS_ENV_PROD : VENUS_ENV_TEST);

export const getSignUrl = () => `/api/scm/customer/venus/sign?bucketName=${getBucketName()}`;

export const disabledZoom = () => {
  // 双指缩放拦截
  document.addEventListener('gesturestart', (e) => e.preventDefault());
};

// 获取客户端平台
export const getPlatform = () =>
  // TODO：完善类型逻辑，确认默认兜底值
  (getFristQueryValue('platform')
  || isInApp() ? (APP_PLATFORM[Mach?.env?.isIOS || isIOS ? 'ios' : 'android']) : APP_PLATFORM.h5
  || APP_PLATFORM.unknow);

// 对象转querystring
export const objectToQueryString = (params: Record<string, any>): string => qs.stringify(params);
